function Loading() {
  return (
    <button
      type="button"
      className="text-primary text-xl 2xl:text-2xl 3xl:text-3xl"
      disabled
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#0278E4"
        className="animate-spin inline mr-3 w-5 lg:w-6 2xl:w-8 3xl:w-10"
      >
        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z" />
      </svg>
      Loading...
    </button>
  );
}

export default Loading;
